import {ApexFont} from "./interfaces";

export const APP_ID = "fontsproto-apex";

export const MIN_MAP_POSITION = 0;
export const MAX_MAP_POSITION = 199;

export const TABLET_MAX_WIDTH = 1024;
export const PHONE_MAX_WIDTH = 700;

export const THROW_RESISTANCE = 1000;

export enum Speeds {
    SLOW,
    MEDIUM,
    FAST,
    SUPER
}
export enum Directions {
    NEUTRAL,
    RIGHT,
    DOWN_RIGHT,
    DOWN,
    DOWN_LEFT,
    LEFT,
    UP_LEFT,
    UP,
    UP_RIGHT
}

export const EMPTY_FONT: ApexFont = {
    isLoaded: false,
    x: 0,
    y: 0,
    font_idx: 0,
    cluster: 0,
    _type: "",
    _isActiveForUser: true,
    _expiryTime: 0,
    _serverTimestamp: 0,
    _filePath: "",
    _fontName: "EMPTY",
    _styleName: "",
    _familyName: "",
    _sortIndex: 0,
    _script: "",
    _supportedLanguages: {},
    _localizedNames: {},
    _accessLevel: "",
    _isPremiumFont: false,
    _isBrowsable: true,
    _isVariableFont: false,
    _variableFamilyPrefix: "",
    _varAxisValues: {},
    _postscriptName: "",
    _osCompatiblePostscriptName: "",
    _fontId: "",
}

//https://p.typekit.net/p.css?s=1&k=bug3cxi&ht=tk&f=7180.7181.7182.7183.22148.22149.22480.22484.22547.22548.22549.22550.22795.22796.42209.42210.42211.45481&a=125730033&app=typekit&e=css
//https://p.typekit.net/p.css?s=1&k=bug3cxi&ht=tk&f=7180.7181.7182.7183.22148.22149.22480.22484.22547.22548.22549.22550.22795.22796.42209.42210.42211.45481&a=125730033&app=typekit&e=css